// src/lib/utils.js
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * CRA env var:
 *   REACT_APP_BACKEND_URL=http://127.0.0.1:8001
 *
 * API_URL => http://127.0.0.1:8001/api
 * BACKEND_ORIGIN => http://127.0.0.1:8001
 */
const backendBase = process.env.REACT_APP_BACKEND_URL?.trim() || "https://glgif.org";

export const BACKEND_ORIGIN = backendBase.replace(/\/+$/, "");
export const API_URL = `${BACKEND_ORIGIN}/api`;

// ✅ Required by Gallery.jsx / AdminGalleryFolder.jsx
export const FALLBACK_IMAGE = "/assets/placeholder.jpg";

/**
 * ✅ Normalize image URLs across:
 * - absolute urls: https://...
 * - backend uploads: /uploads/...
 * - public assets: /assets/...
 * - empty/null -> fallback
 */
export function normalizeImageUrl(url, fallback = FALLBACK_IMAGE) {
  const u = String(url || "").trim();
  if (!u) return fallback;

  // absolute or special
  if (/^(https?:)?\/\//i.test(u) || u.startsWith("data:") || u.startsWith("blob:")) return u;

  // public folder asset
  if (u.startsWith("/assets/")) return u;

  // backend uploads path
  if (u.startsWith("/uploads/")) return `${BACKEND_ORIGIN}${u}`;

  // any other absolute-like path
  if (u.startsWith("/")) return `${BACKEND_ORIGIN}${u}`;

  // already relative/filename
  return u;
}

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatTime = (timeString) => {
  return timeString || "";
};

export const truncateText = (text, maxLength) => {
  if (!text) return "";
  const s = String(text);
  if (s.length <= maxLength) return s;
  return s.substring(0, maxLength) + "...";
};

export const getCategoryLabel = (category) => {
  const labels = {
    humanitarian_impact: "Humanitarian Impact",
    child_welfare: "Child Welfare & Education",
    rights_inclusion: "Rights & Inclusion",
    technology_for_good: "Technology for Good",
    climate_community: "Climate & Community",
    partner_stories: "Partner/Volunteer Stories",
    outreach: "Outreach",
    campaign: "Campaign",
    training: "Training",
    advocacy: "Advocacy",
    community_visit: "Community Visit",
  };
  return labels[category] || category;
};

export const getStatusColor = (status) => {
  const colors = {
    upcoming: "bg-amber-100 text-amber-800",
    ongoing: "bg-green-100 text-green-800",
    completed: "bg-blue-100 text-blue-800",
  };
  return colors[status] || "bg-gray-100 text-gray-800";
};